import { normalize_pin_role_value } from './pinInference';

const build_pin_override_map = (overrides) => {
  return Object.fromEntries(
    Object.entries(overrides).map(([key, value]) => [key.toLowerCase(), value])
  );
};

export const BOARD_PROFILES = [
  {
    id: 'esp8266-nodemcu',
    match: (board) => {
      const slug = String(board?.slug || '').trim().toLowerCase();
      const name = String(board?.name || '').trim().toLowerCase();
      const manufacturer = String(board?.manufacturer || '').trim().toLowerCase();

      return (
        slug.includes('nodemcu') ||
        name.includes('nodemcu') ||
        name.includes('lolin module') ||
        (manufacturer.includes('lolin') && name.includes('esp8266')) ||
        (name.includes('esp8266') && name.includes('v3.0'))
      );
    },
    board_overrides: {
      logic_voltage_min_v: 0,
      logic_voltage_max_v: 3.3,
      supported_protocols: ['i2c', 'spi', 'uart'],
      analysis_confidence: 'medium',
    },
    pin_overrides: build_pin_override_map({
      D0: {
        gpio: 'GPIO16',
        pin_role: 'gpio',
        capability_tags: ['gpio'],
        restrictions: ['limited_interrupt_support'],
      },
      D1: {
        gpio: 'GPIO5',
        pin_role: 'gpio',
        capability_tags: ['gpio', 'i2c-scl'],
      },
      D2: {
        gpio: 'GPIO4',
        pin_role: 'gpio',
        capability_tags: ['gpio', 'i2c-sda'],
      },
      D3: {
        gpio: 'GPIO0',
        pin_role: 'gpio',
        capability_tags: ['gpio'],
        restrictions: ['boot_sensitive'],
        safe_usage_notes: ['GPIO0 must stay HIGH during boot.'],
      },
      D4: {
        gpio: 'GPIO2',
        pin_role: 'gpio',
        capability_tags: ['gpio'],
        restrictions: ['boot_sensitive', 'onboard_led'],
        safe_usage_notes: ['GPIO2 must stay HIGH during boot.'],
      },
      D5: {
        gpio: 'GPIO14',
        pin_role: 'gpio',
        capability_tags: ['gpio', 'spi-sck', 'pwm'],
      },
      D6: {
        gpio: 'GPIO12',
        pin_role: 'gpio',
        capability_tags: ['gpio', 'spi-miso', 'pwm'],
      },
      D7: {
        gpio: 'GPIO13',
        pin_role: 'gpio',
        capability_tags: ['gpio', 'spi-mosi', 'pwm'],
      },
      D8: {
        gpio: 'GPIO15',
        pin_role: 'gpio',
        capability_tags: ['gpio', 'spi-cs', 'pwm'],
        restrictions: ['boot_sensitive'],
        safe_usage_notes: ['GPIO15 must stay LOW during boot.'],
      },
      A0: {
        pin_role: 'analog-input',
        capability_tags: ['analog', 'analog-input'],
        electrical_type: 'analog_input',
      },
      RX: {
        pin_role: 'uart-rx',
        capability_tags: ['uart', 'uart-rx'],
        restrictions: ['serial_programming'],
      },
      TX: {
        pin_role: 'uart-tx',
        capability_tags: ['uart', 'uart-tx'],
        restrictions: ['serial_programming'],
      },
      EN: {
        pin_role: 'enable',
        electrical_type: 'special',
      },
      RST: {
        pin_role: 'reset',
        electrical_type: 'special',
      },
      S0: {
        pin_role: 'flash-data',
        restrictions: ['used_by_flash', 'avoid_for_gpio'],
      },
      S1: {
        pin_role: 'flash-data',
        restrictions: ['used_by_flash', 'avoid_for_gpio'],
      },
      S2: {
        pin_role: 'flash-data',
        restrictions: ['used_by_flash', 'avoid_for_gpio'],
      },
      S3: {
        pin_role: 'flash-data',
        restrictions: ['used_by_flash', 'avoid_for_gpio'],
      },
      SC: {
        pin_role: 'flash-data',
        restrictions: ['used_by_flash', 'avoid_for_gpio'],
      },
      SK: {
        pin_role: 'flash-data',
        restrictions: ['used_by_flash', 'avoid_for_gpio'],
      },
      GND: {
        pin_role: 'ground',
      },
      VIN: {
        pin_role: 'power-input',
      },
      '3V3': {
        pin_role: 'power-output',
      },
      '5V': {
        pin_role: 'power-output',
      },
      VU: {
        pin_role: 'power-output',
      },
    }),
  },
];

export const find_board_profile = (board) => {
  return BOARD_PROFILES.find((profile) => profile.match(board)) || null;
};

export const normalize_profile_pin_role = (value) => {
  return normalize_pin_role_value(value);
};
